import { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import Footer from '../components/Footer';
import Header from '../components/Header';
import MobileSideMenu from '../components/MobileSideMenu';
import World from '../assets/world.svg';
import WorldMedium from '../assets/world-medium.svg';
import useWake from '../helpers/useWakeServer';

function WaitList() {
  const { isWaking, wakeServer, shouldWakeServer } = useWake();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  function toggleMobileMenuOpen() {
    setMobileMenuOpen(!mobileMenuOpen);
  }

  // Validate the form whenever email input changes
  function handleEmailChange(event) {
    const inputEmail = event.target.value;
    setEmail(inputEmail);

    // Simple email validation
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputEmail);
    setIsFormValid(isValidEmail);
  }

  // Handle form submission
  async function handleSubmit(event) {
    event.preventDefault(); // Prevent form default action
    setIsSubmitting(true);

    const formData = { email };

    try {
      if (shouldWakeServer()) {
        await wakeServer();
      }

      const response = await fetch('https://gartekweb.onrender.com/wait-list', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        if (response.status === 409) {
          toast.info('You are already a user', {
            toastId: 1,
          });
          return;
        }
        throw new Error('Failed to submit form.');
      }

      // Optionally, show success feedback
      toast.success('Successfully joined the waitlist!', {
        toastId: 2,
      });
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        toastId: 3,
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <>
      <MobileSideMenu open={mobileMenuOpen} toggleOpen={toggleMobileMenuOpen} />
      <Header toggleMobileMenu={toggleMobileMenuOpen} />
      <main>
        <section className="flex flex-col items-center py-8 px-5">
          <div className="md:max-w-2xl flex flex-col items-center">
            <h1 className="text-3xl bg-gold-variant py-5 px-10 rounded-2xl font-bold text-gold mb-3 md:mb-5 md:py-9 md:px-16 md:rounded-3xl md:text-4xl">
              Join Our Waitlist!
            </h1>
            <p className="text-[10px] text-black-opaque-4 max-w-56 md:max-w-none text-center md:text-sm">
              Be among the first Persons to use GartekCloude when it launches!
            </p>
            <form
              onSubmit={handleSubmit}
              className="flex gap-1 py-1 px-1.5 md:py-2 md:px-3.5 rounded-lg md:rounded-xl bg-white-variant my-10 w-full"
            >
              <div className="flex flex-1 items-center">
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={handleEmailChange}
                  placeholder="Enter your email"
                  className="px-2 py-1 w-full h-full bg-white-variant text-[8px] hover:text-sm md:text-xs md:hover:text-base focus:outline-none focus:border-0"
                  required
                />
              </div>
              <div className="form-row btn-container">
                <button
                  className={`bg-gold rounded-md text-white text-lg font-bold py-4 px-6 ${
                    isFormValid
                      ? 'border-gold'
                      : 'opacity-35 border-gray-400 cursor-not-allowed'
                  }`}
                  type="submit"
                  disabled={!isFormValid || isSubmitting || isSubmitting}
                >
                  {isSubmitting || isWaking ? 'Adding You...' : 'Join WaitList'}
                </button>
              </div>
            </form>
          </div>
        </section>
        <div>
          <picture>
            <source media="(min-width: 768px)" srcSet={WorldMedium} />
            <img src={World} alt="" className="w-full" />
          </picture>
        </div>
      </main>
      <Footer />
      <ToastContainer containerId={1} />
      <ToastContainer containerId={2} />
      <ToastContainer containerId={3} />
      <ToastContainer containerId={4} />
      <ToastContainer containerId={5} />
      <ToastContainer containerId={6} />
    </>
  );
}

export default WaitList;
